const comments = [
  {
    name: '追剧达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Chinese%20man%20with%20warm%20smile%2C%20casual%20style%2C%20clean%20studio%20background%20with%20soft%20natural%20lighting%2C%20friendly%20expression%2C%20editorial%20quality&width=80&height=80&seq=avatar-1&orientation=squarish',
    time: '2小时前',
    content: '黑桃视频真的太方便了！西瓜视频免费和丝瓜视频的资源都能在这里找到，而且真的不缓冲，追剧体验比在其他平台好太多了。已经推荐给身边所有追剧的朋友了！',
    likes: '328',
  },
  {
    name: '电影发烧友阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Chinese%20man%20with%20stylish%20glasses%2C%20modern%20casual%20look%2C%20clean%20studio%20background%20with%20warm%20lighting%2C%20confident%20expression%2C%20editorial%20quality&width=80&height=80&seq=avatar-2&orientation=squarish',
    time: '5小时前',
    content: '电影大全这个功能太赞了！港片专区收录了几百部经典，画质都很高清，周末一口气重温了《英雄本色》《无间道》好几部经典，满满的回忆杀。希望持续更新更多资源！',
    likes: '256',
  },
  {
    name: '动漫迷小琳',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20gentle%20smile%2C%20casual%20style%2C%20clean%20studio%20background%20with%20soft%20natural%20lighting%2C%20friendly%20expression%2C%20editorial%20quality&width=80&height=80&seq=avatar-3&orientation=squarish',
    time: '8小时前',
    content: '作为国漫爱好者，黑桃视频的动漫番剧专区就是我的快乐源泉！《仙道至尊》每周更新都能第一时间看到，画质超清晰，而且完全免费，太良心了这个平台。',
    likes: '189',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            用户反馈
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            来看看真实用户对黑桃视频的评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-[1100px] mx-auto">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-2xl p-5 md:p-6 hover:border-background-300/80 transition-colors duration-200"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>

              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {comment.content}
              </p>

              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}